<template>
  <div v-if="isVisible" class="panel">
    <slot></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isVisible: false,
    }
  },
  methods: {
    show() {
      this.isVisible = true
    },

    hide() {
      this.isVisible = false
    },

    toggle(visibility) {
      if (visibility === undefined) {
        this.isVisible = !this.isVisible
      } else {
        this.isVisible = !visibility
      }
    },

    getVisibility() {
      return this.isVisible
    },
  },
}
</script>

<style lang="scss" scoped>
.panel {
  @apply rounded-lg my-3 mr-2 border border-base-30 overflow-hidden bg-base-0 relative;
  width: 384px;
  height: calc(100% - 1.5rem);
  box-shadow: 0px 10px 38px 0px #525F7F08;
  transform: scale(1); // to make settings-header fixed and follow this parent
  &.disabled {
    @apply cursor-not-allowed;
  }
}
</style>
